/**
 * Copyright (c) 2024-2026 Creative Agentics Limited. All rights reserved.
 * Proprietary and confidential.
 *
 * WELCOME EMAIL ONLY ONCE THE CASE IS APPROVED (owner 16/10/2026). The welcome
 * email tells the client their onboarding is approved, so it may be sent only
 * when the case's status is 'approved': after the MLRO's approval where the
 * firm approves directly, after the second signatory approves where the firm
 * uses second sign off (pending_director_review is not approved), after the
 * external review's activation, or after a migrated client is accepted. The
 * server enforces it (api/welcome-approved.js); the dashboard uses the same
 * wording to say why the button is not available. No dashes in any text here.
 */
export const WELCOME_ALLOWED_STATUS = 'approved';

/** null when the welcome email may be sent; otherwise the reason, for the officer. */
export function welcomeBlock(status) {
  const s = String(status || '');
  if (s === WELCOME_ALLOWED_STATUS) return null;
  if (s === 'pending_director_review') return 'The welcome email can be sent once the second signatory has approved the case.';
  if (s === 'director_returned') return 'The second signatory returned the case, so it is not approved. The welcome email can be sent once it is approved.';
  if (s === 'jaybee_approved') return 'The welcome email is sent when the relationship is activated.';
  return 'The welcome email can be sent only once the case is approved.';
}
